export default [
    { text: 'Nome do cliente', sortable: false, value: 'clientName' },
    { text: 'ID do cliente', sortable: false, value: 'clientId', align: 'center' },
    { text: 'Elegibilidade', sortable: false, value: 'eligibility', align: 'center' },
    { text: 'Tipo do lastro', sortable: false, value: 'coverageType', align: 'center' },
    { text: 'Número do lastro', sortable: false, value: 'coverageNumber', align: 'center' },
    { text: 'Vencimento', sortable: false, value: 'coverageDueDate', align: 'center' },
];
